import Vue from 'vue'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import VueShortkey from 'vue-shortkey'
import VueTheMask from 'vue-the-mask'
import router from './router'
import Snackbar from '@/plugins/snackbar/snackbar.js'
import LoggedUser from '@/plugins/logged-user/loggedUser.js'
import Permission from '@/plugins/permission/permission.js'
import Whitelabel from './plugins/whitelabel/whitelabel.js'
import Microservices from '@/plugins/microservices/microservices.js'
import Confirm from '@/plugins/confirm/confirm.js'
import 'regenerator-runtime/runtime'

import { createPinia, PiniaVuePlugin } from 'pinia'
import { apolloProvider } from '@/apollo-provider.js'

import './plugins/mf-vue-components'

import App from './App.vue'

const pinia = createPinia()
Vue.use(PiniaVuePlugin)
Vue.use(Whitelabel, { env: process.env })
Vue.use(Microservices, { env: process.env })
Vue.use(Confirm, { vuetify })
Vue.use(LoggedUser)
Vue.use(Permission)
Vue.use(Vuelidate)
Vue.use(VueShortkey)
Vue.use(VueTheMask)
Vue.use(Snackbar)

router.beforeEach((to, from, next) => {
  if (!to.meta.unauthAllowed && !Vue.isLogged()) {
    next({
      path: '/expired-session',
    })
  } else {
    next()
  }
})

new Vue({
  pinia,
  vuetify,
  router,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app')
